import { DROPDOWN_EVENTS } from '@/core/values/core.values';
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

@Component({})
class EdDropdown extends Vue {
  
  @Prop() readonly name: string;
  @Prop() readonly align: string;
  @Prop() readonly open: any;
  @Prop() readonly opened: boolean;
  @Prop() readonly notBorderOpened: boolean;
  @Prop() readonly hasBorderFull: boolean;
  @Prop() readonly manual: boolean;
  @Prop() readonly color: string;

  public menuOpened: boolean = false;

  get position(): string {
    return this.align ? this.align : 'left';
  }

  get isOpened(): boolean {
    if(this.manual) {
      return this.opened;
    } else {
      return this.menuOpened;
    }
  }

  get selectedColor(): string {
    return this.color ? `ed-dropdown--opened-${this.color}`: 'ed-dropdown--opened-green';
  }

  get dropdownClasses(): any {
    return {
      'ed-dropdown--not-border-opened': this.isOpened && this.notBorderOpened,
      'ed-dropdown--border-full': !this.isOpened && this.hasBorderFull,
    }
  }

  get titleClasses(): any {
    return {
      'ed-dropdown__title--right': this.position == 'right',
      'ed-dropdown__title--opened': this.isOpened,
      [this.selectedColor]: true
    }
  }

  tap() {
    if(!this.manual) {
      this.menuOpened = !this.menuOpened;
    } 
    if(this.name) {
      this.$edEventBus.$emit(DROPDOWN_EVENTS.OPEN_ED_DROPDOWN, this['_uid']);
    }
    this.$emit('open', this.menuOpened);
  }

  setOpened(uidOpened: number) {
    let uid: number = this['_uid'];
    if(uid !== uidOpened) {
      this.menuOpened = false;
    }
  }

  created() {
    this.menuOpened = this.opened;
    if(this.name && !this.manual) {
      this.$edEventBus.$on(DROPDOWN_EVENTS.OPEN_ED_DROPDOWN, this.setOpened);
    }
  }

  beforeDestroy() {
    if(this.name && !this.manual) {
      this.$edEventBus.$off(DROPDOWN_EVENTS.OPEN_ED_DROPDOWN, this.setOpened);
    }
  }

}

export default Vue.component('ed-dropdown', EdDropdown);